/*create by ma.rongqin 2016/10/18*/
"use strict";
angular.module('manageSysManageSourceManageNewModule', [])
    .controller('manageSysManageSourceManageNewCtrl', ['$scope', "$modalInstance", '$validation', '$timeout', 'modalDialog', 'curItem',
        function($scope, $modalInstance, $validation, $timeout, modalDialog, curItem) {
            initStatus();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    sourceName: curItem ? curItem.SRCNAME : '',
                    sourceDescribe: curItem ? curItem.SRCDESC : '',
                    sourceLink: curItem ? curItem.SRCLINK : '',
                };
                $scope.title = curItem ==="" ? "添加" : "修改";
            }
            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                if ($scope.status.sourceName == '-1') {
                    modalDialog.alertType("保存失败", "【-1】为保留字", "error", false);
                }
                $validation.validate($scope.sourceManageNewView).success(function() {
                    $modalInstance.close($scope.status);
                });
            };
        }
    ]);
